// Single source of truth for per-page <SEO> metadata (SEO-PLAYBOOK.md Phase 2 /
// Appendix A). Note: this lives under src/, not the repo root the playbook
// suggests — CRA's ModuleScopePlugin refuses imports from outside src/, so a
// repo-root seo/pages.config.js would fail to compile.
//
// noindex: true marks routes that are functional but not meant to be indexed —
// legacy template pages (Blog/Service/Team/CaseStudy, never linked from the
// live nav — see the Phase 0/1 recon), unfinished placeholders (Innovation),
// the 404 page, and the old demo homepages (index-2..5).

export const SITE = {
  origin: "https://evolvelab.co",
  brand: "EvolveLab",
  defaultOgImage: "https://evolvelab.co/assets/img/banner-5/5.png",
};

export const PAGES = {
  "/": {
    title: "Startup Funding & Accelerator Programs for Canadian Founders",
    description:
      "We help Canadian founders develop, accelerate, and fund investor-ready businesses through structured clarity, accelerated execution, and capital alignment. From seed to scale.",
  },
  "/about": {
    title: "About EvolveLab - Accelerator Program for Canadian Startups",
    description:
      "Build faster, learn smarter, and move with momentum. The EvolveLab Accelerator helps founders ready to accelerate execution with guided momentum and structured support.",
  },
  "/funding/jumpstart": {
    title: "Funding Jumpstart - Get Clear Before You Raise",
    description:
      "Most startups don't need money first — they need clarity. Our Funding Jumpstart program helps early-stage founders get clear on their funding path and reduce risk.",
  },
  "/funding/boost": {
    title: "Funding Boost - Become Investor-Ready",
    description:
      "Transform your startup into a fundable business. Our Funding Boost program prepares startups to raise grants or equity with investor-ready positioning and stronger pitches.",
  },
  "/funding/advisory": {
    title: "Funding Advisory - Strategic Capital Done Right",
    description:
      "Hands-on, fractional-level funding advisory for growth-stage companies. Get capital alignment, better terms, and fewer costly mistakes with expert guidance.",
  },
  "/fundinglab": {
    title: "Funding Lab - A 10-Week Capital-Readiness Program",
    description:
      "Funding Lab helps Canadian founders design and execute the right capital strategy — grants, customer financing, angels, venture capital, debt, or a blended stack — with the pipelines, materials and 90-day plan to go get it.",
  },
  "/accelerator/dev-sprint": {
    title: "Dev Sprint - Turn Strategy Into Action",
    description:
      "Translate your startup strategy into real execution with clear build plans. Our Dev Sprint program helps startups move now with focused execution and faster delivery.",
  },
  "/accelerator/dev-build": {
    title: "Dev Build & Scale - Build With Purpose, Scale With Confidence",
    description:
      "Product development aligned with investor expectations and built for scale. Reduce rebuild risk and create a scalable foundation for your startup.",
  },
  "/accelerator/dev-scale": {
    title: "Dev Scale - Strengthen Product and Expand With Confidence",
    description:
      "Strengthen product, security, partnerships, and market expansion with embedded execution support for Canadian startups ready to scale.",
  },
  "/portfolio": {
    title: "Portfolio - Our Startups and Success Stories",
    description:
      "Discover the innovative startups and founders we've helped accelerate and fund. See real outcomes from EvolveLab's portfolio companies.",
  },
  "/careers": {
    title: "Careers - Build What Matters, Shape What's Next",
    description:
      "Join EvolveLab and work on real startups, real products, and real outcomes. We're looking for product leaders, engineers, designers, and advisors to shape the future of innovation.",
  },
  "/contact": {
    title: "Contact Us - Get in Touch With EvolveLab",
    description:
      "Ready to start your journey? Contact EvolveLab to discuss funding opportunities, accelerator programs, or development services for your startup.",
  },
  "/apply": {
    title: "Apply Now - Join the EvolveLab Program",
    description:
      "Apply to EvolveLab's funding and accelerator programs. Kickstart your idea and access the resources, mentorship, and capital you need to succeed.",
  },
  "/terms": {
    title: "Terms and Conditions",
    description: "Terms governing use of EvolveLab's website and services.",
  },
  "/privacy": {
    title: "Privacy Policy",
    description:
      "How EvolveLab Solutions Inc. collects, uses, and protects personal information submitted through evolvelab.co.",
  },
  "/404": {
    title: "Page Not Found - 404",
    description:
      "The page you're looking for doesn't exist. Return to the EvolveLab homepage to explore our startup funding and accelerator programs.",
    noindex: true,
  },

  // --- Not indexed: unfinished, legacy, or demo-only routes ---
  "/innovation": {
    title: "Innovation",
    description: "This page is under construction.",
    noindex: true,
  },
  "/index-2": { title: "Home (legacy demo)", description: "Legacy template demo page.", noindex: true },
  "/index-3": { title: "Home (legacy demo)", description: "Legacy template demo page.", noindex: true },
  "/index-4": { title: "Home (legacy demo)", description: "Legacy template demo page.", noindex: true },
  "/index-5": { title: "Home (legacy demo)", description: "Legacy template demo page.", noindex: true },
  "/blog": { title: "Blog", description: "EvolveLab blog.", noindex: true },
  "/blog-details": { title: "Blog Post", description: "EvolveLab blog post.", noindex: true },
  "/case-study-details": { title: "Case Study", description: "EvolveLab case study.", noindex: true },
  "/service": { title: "Service", description: "EvolveLab service.", noindex: true },
  "/service-details": { title: "Service Details", description: "EvolveLab service details.", noindex: true },
  "/funding/launch": { title: "Service Details", description: "EvolveLab service details.", noindex: true },
  "/team": { title: "Team", description: "EvolveLab team.", noindex: true },
  "/team-details": { title: "Team Details", description: "EvolveLab team member details.", noindex: true },
};

export const getPageMeta = (path) => PAGES[path] || {};
